import * as React from 'react';
import { overridedIcons } from '../../../../../../Icons';
import { Field } from '../../../../../../Passenger/components/Field/Field';
import { useTheme } from '../../../../../../theme';
import { useTranslation } from 'react-i18next';
import Checkbox from './Checkbox/Checkbox';
import { AviaPassengerType } from '@websky/graphql';
import { AdditionalTravellerFieldEnum, PassengerField } from '../../../../../../Passenger/types';

interface Props {
	passengerId: number;
	passengerType: AviaPassengerType;
	disabled?: boolean;
	accompanyingFields?: PassengerField[];
}

const Accompanying: React.FC<Props> = props => {
	const theme = useTheme('PassengerForm').Accompanying;
	const { t } = useTranslation('Passenger');

	if (!props.accompanyingFields?.length) {
		return null;
	}

	return (
		<div className={theme.accompanying}>
			<div className={theme.accompanying__header}>{t('Booking details of the accompanying passenger')}</div>
			<div className={theme.accompanying__info}>
				{overridedIcons['InfoDetails']}
				<div>
					{t(
						'Fill in the fields with the booking details of the accompanying passenger over 18 years of age. Please note that the flight dates, flight and class of service for both passengers must be the same.'
					)}
				</div>
			</div>
			<div className={theme.fields}>
				{props.accompanyingFields
					.filter(field => field.type !== AdditionalTravellerFieldEnum.AccompanyingCheck)
					.map((field, index) => (
						<Field
							disabled={field.readonly || props.disabled}
							key={`${field.name}_${index}`}
							field={{
								...field,
								name: `customer.${field.name}`
							}}
							passengerId={props.passengerId}
							passengerType={props.passengerType}
						/>
					))}
			</div>
			<Checkbox accompanyingFields={props.accompanyingFields} />
		</div>
	);
};

export default Accompanying;
